
// export const myGetter = ( state ) => {
//  return state
// }

export const usersList = state => state.users
export const usersSelectable = state => state.usersSelectable
export const usersPaginatedData = state => state.usersPaginatedData
export const user = state => state.user
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData
export const isFinding = state => state.isLoading
export const foundData = state => state.foundData
